import ProductDeliveryPeriodsStore from '../store/ProductDeliveryPeriodsStore';
import { fetchFromJson } from './fetchFromJson';

const db = new ProductDeliveryPeriodsStore('productDeliveryPeriodsStore');

const updateCache = 'deliveryPeriodAssignments_updateCache';
const getUpdateCache = (data) => data.delivery_period_assignments;
const toast = 'Product Delivery Periods Updated';
const entityName = 'productDeliveryPeriods';

export default (WrappedComponent) => fetchFromJson({
  WrappedComponent,
  getUpdateCache,
  db,
  updateCache,
  toast,
  entityName,
});
